import type { ExcelColumn } from '../../../utils/excelExport';
import { AUDIT_EXPORT_COLUMNS } from '../../../lib/auditColumnDefs';
import type { UserColumnFilterKey, UserColumnFilters } from '../models/types';

export const ACCENT_COLORS = [
  '#5c6bc0', '#26a69a', '#ffa502', '#ff6b6b', '#a78bfa', '#2ed573', '#ff9f43',
];

export const RECENT_LOGINS_DISPLAY_LIMIT = 5;

export const SEARCH_DEBOUNCE_MS = 400;

export const EMPTY_USER_FORM = {
  id: 0,
  userType: '',
  name: '',
  email: '',
  password: '',
  roleId: 0,
  merchantId: '',
  status: 'Active',
  sendNotification: true,
  checkoutLinkEmailEnabled: true,
  liveDccEnabled: false,
  merchantIds: [] as string[],
  twoFactorEnabled: true,
  dashboardKey: 'DEFAULT',
};

export const EMPTY_USER_COLUMN_FILTERS: UserColumnFilters = {
  name: null,
  email: null,
  role: null,
  status: null,
  lastLogin: null,
};

export const USER_COLUMN_FILTER_LABELS: Record<UserColumnFilterKey, string> = {
  name: 'User',
  email: 'Email',
  role: 'Role',
  status: 'Status',
  lastLogin: 'Last Login',
};

/** Same string as createUserColumnDefs Merchant Name headerName. */
export const USER_MERCHANT_NAME_HEADER = 'Merchant Name';

export const USER_EXPORT_COLUMNS: ExcelColumn[] = [
  // Same columns and visual order as createUserColumnDefs (Actions excluded). Status is pinned right.
  { header: USER_COLUMN_FILTER_LABELS.name, key: 'name' },
  { header: USER_COLUMN_FILTER_LABELS.email, key: 'email' },
  { header: USER_MERCHANT_NAME_HEADER, key: 'merchantName' },
  { header: USER_COLUMN_FILTER_LABELS.role, key: 'role' },
  { header: USER_COLUMN_FILTER_LABELS.lastLogin, key: 'lastLogin' },
  ...AUDIT_EXPORT_COLUMNS,
  { header: USER_COLUMN_FILTER_LABELS.status, key: 'status' },
];

export const USER_COLUMN_LABELS = USER_COLUMN_FILTER_LABELS;

export const USER_COLUMN_FILTER_KEYS: UserColumnFilterKey[] = [
  'name',
  'email',
  'role',
  'status',
  'lastLogin',
];
